export default __webpack_public_path__ + "static/media/logooo.9bee02fe.png";